import { useContext, useEffect, useRef } from "react";
import { MyContext } from "../../Context/MyProvider";
import { showTost } from "../../showTost";
import axios from "axios";

const CCAvenue = ({ Amount }) => {
    const { BaseUrl, setPaymentLod } = useContext(MyContext);

    const requestStarted = useRef(false);

    useEffect(() => {
        if (requestStarted.current) return;

        requestStarted.current = true;

        const createCCAvenueOrder = async () => {
            setPaymentLod(true);

            try {
                const loginData = JSON.parse(
                    localStorage.getItem("LoginData") || "{}"
                );

                const phone =
                    loginData.mobile ||
                    loginData.mobileNo ||
                    localStorage.getItem("mobile") ||
                    "";

                const name =
                    loginData.name ||
                    loginData.username ||
                    "";

                const email = loginData.email || "";

                if (!name || !email || !phone) {
                    showTost(
                        "Your name, email, and mobile number are required for CCAvenue payment.",
                        "error"
                    );
                    return;
                }

                const { data } = await axios.post(
                    `${BaseUrl}user_api/create_order.php`,
                    {
                        amount: Amount,
                        payment_method: "ccavenue",
                        name,
                        email,
                        phone,
                    }
                );

                console.log("CCAvenue Response:", data);

                if (
                    (data?.status === true || data?.status === "true") &&
                    data?.ccavenue_url
                ) {
                    const orderId =
                        data.ccavenue_order_id || data.order_id;

                    if (orderId) {
                        sessionStorage.setItem(
                            "CCAVenueOrderId",
                            orderId
                        );
                    }

                    sessionStorage.setItem(
                        "Amount",
                        String(Amount)
                    );

                    // Open CCAvenue in a small browser window
                    const paymentWindow = window.open(
                        data.ccavenue_url,
                        "CCAvenuePayment",
                        "width=900,height=700,left=200,top=100,resizable=yes,scrollbars=yes"
                    );

                    if (!paymentWindow) {
                        showTost(
                            "Please allow pop-ups in your browser to continue payment.",
                            "error"
                        );
                        return;
                    }

                    paymentWindow.focus();

                    return;
                }

                showTost(
                    data?.message ||
                        "CCAvenue payment URL not received",
                    "error"
                );
            } catch (error) {
                console.error(
                    "CCAvenue order creation failed:",
                    error
                );

                showTost(
                    error.response?.data?.message ||
                        "Payment initialization failed",
                    "error"
                );
            } finally {
                setPaymentLod(false);
            }
        };

        createCCAvenueOrder();
    }, [Amount, BaseUrl, setPaymentLod]);

    return null;
};

export default CCAvenue;